// AWS本番環境設定
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Auth: {
    region: "ap-northeast-1",
    userPoolId: "ap-northeast-1_iKpGxRjjD",
    userPoolWebClientId: "6d09mosad4c7s57dnflstg2bpe"
  },
  API: {
    endpoints : [
      {
        name: "seomportal_v1",
        endpoint: "https://mwajmrbm12.execute-api.ap-northeast-1.amazonaws.com/v1/om"
      },
      {
        name: "seomportal_dev",
        endpoint: "https://mwajmrbm12.execute-api.ap-northeast-1.amazonaws.com/dev/om"
      }
    ]
  },
} 

// AWS開発環境設定
// eslint-disable-next-line import/no-anonymous-default-export
// export default {
//   Auth: {
//     region: "ap-northeast-1",
//     userPoolId: "ap-northeast-1_6WEjaXqR3",
//     userPoolWebClientId: "7pno4tcoseghgak98ghiteefhm"
//   },
//   API: {
//     endpoints : [
//       {
//         name: "seomportal_v1",
//         endpoint: "https://r2w0loxcn3.execute-api.ap-northeast-1.amazonaws.com/dev/om"
//       }
//     ]
//   },
// }

// AWSステージ環境設定
// eslint-disable-next-line import/no-anonymous-default-export
// export default {
//   Auth: {
//     region: "ap-northeast-1",
//     userPoolId: "ap-northeast-1_FcDXZd8lc",
//     userPoolWebClientId: "6titukk2ilj4mbrlecefohpv9e"
//   },
//   API: {
//     endpoints : [
//       {
//         name: "seomportal_v1",
//         endpoint: "https://v2lkpk5k8k.execute-api.ap-northeast-1.amazonaws.com/dev/om"
//       }
//     ]
//   },
// }